import React from 'react';
import { InfoIcon } from 'lucide-react';
import { APP_CONFIG } from '../../config/constants';
interface Props {
  className?: string;
}
export const FileTypeHelper = ({
  className = ''
}: Props) => {
  const formatFileType = (mimeType: string): string => {
    const types: Record<string, string> = {
      'application/pdf': 'PDF',
      'application/msword': 'DOC',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
      'text/plain': 'TXT',
      'text/markdown': 'MD',
      'text/csv': 'CSV',
      'application/json': 'JSON',
      'text/xml': 'XML',
      'text/html': 'HTML'
    };
    return types[mimeType] || mimeType;
  };
  return <div className={`flex items-start gap-3 ${className}`} data-id="element-402">
      <InfoIcon size={20} className="text-gray-400 shrink-0 mt-0.5" data-id="element-403" />
      <div data-id="element-404">
        <p className="text-sm text-gray-400" data-id="element-405">
          Supported file types:{' '}
          {APP_CONFIG.SUPPORTED_FILE_TYPES.map(formatFileType).join(', ')}
        </p>
        <p className="text-sm text-gray-400 mt-1" data-id="element-406">
          Maximum file size: {APP_CONFIG.MAX_FILE_SIZE / (1024 * 1024)}MB
        </p>
        <p className="text-sm text-gray-400 mt-1" data-id="element-407">
          Maximum files per upload: {APP_CONFIG.MAX_UPLOAD_FILES}
        </p>
      </div>
    </div>;
};